export const state = () => ({
  loading: false,
  eventForm: null,
  thankYou: null,
  doubleOptIn: null,
  meta: null,
  stage: null,
  intro: null,
  information: null,
  location: null,
  agenda: null,
  download: null,
  boxes: null,
  content: null,
  presenters: null,
  teaser: null,
  formular: null,
  formularFields: null
})
export const getters = {
  loading(state) {
    return state.loading
  },
  eventForm(state) {
    return state.eventForm
  },
  thankYou(state) {
    return state.thankYou
  },
  doubleOptIn(state) {
    return state.doubleOptIn
  },
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  intro(state) {
    return state.intro
  },
  information(state) {
    return state.information
  },
  location(state) {
    return state.location
  },
  agenda(state) {
    return state.agenda
  },
  download(state) {
    return state.download
  },
  boxes(state) {
    return state.boxes
  },
  content(state) {
    return state.content
  },
  presenters(state) {
    return state.presenters
  },
  teaser(state) {
    return state.teaser
  },
  formular(state) {
    return state.formular
  },
  formularFields(state) {
    return state.formularFields
  }
}
export const mutations = {
  setLoading(state, newState) {
    state.loading = newState
  },
  setEventForm(state, { data }) {
    state.eventForm = data
  },
  setThankYou(state, { data }) {
    state.thankYou = data
  },
  setDoubleOptIn(state, { data }) {
    state.doubleOptIn = data
  },
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setIntro(state, { data }) {
    state.intro = data
  },
  setInformation(state, { data }) {
    state.information = data
  },
  setLocation(state, { data }) {
    state.location = data
  },
  setAgenda(state, { data }) {
    state.agenda = data
  },
  setDownload(state, { data }) {
    state.download = data
  },
  setBoxes(state, { data }) {
    state.boxes = data
  },
  setContent(state, { data }) {
    state.content = data
  },
  setPresenters(state, { data }) {
    state.presenters = data
  },
  setTeaser(state, { data }) {
    state.teaser = data
  },
  setFormular(state, { data }) {
    state.formular = data
  },
  setFormularFields(state, { data }) {
    state.formularFields = data
  }
}
export const actions = {
  sendEventForm(
    { commit, rootState },
    { name, email, company, terms, eventName }
  ) {
    commit('setLoading', true)
    return this.$axios
      .post(`${window.location.origin}/api/events`, {
        name: name,
        email: email,
        company: company,
        terms: terms,
        event: eventName,
        language: rootState.language
      })
      .then(() => {
        commit('setLoading', false)
      })
      .catch((err) => {
        commit('setLoading', false)
        console.error(err)
      })
  },
  getEventForm({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/event_form.json`)
      .then((res) => {
        commit('setEventForm', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getThankYou({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/event_thank_you.json`)
      .then((res) => {
        commit('setThankYou', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getDoubleOptIn({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/event_double_opt_in.json`)
      .then((res) => {
        commit('setDoubleOptIn', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getMeta({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(`${rootState.language}/homepage/${company}/events/${page}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/stage.json`
      )
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getIntro({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/intro.json`
      )
      .then((res) => {
        commit('setIntro', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getInformation({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/information.json`
      )
      .then((res) => {
        commit('setInformation', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getLocation({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/location.json`
      )
      .then((res) => {
        commit('setLocation', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getAgenda({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/agenda.json`
      )
      .then((res) => {
        commit('setAgenda', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getDownload({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/download.json`
      )
      .then((res) => {
        commit('setDownload', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getBoxes({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/boxes.json`
      )
      .then((res) => {
        commit('setBoxes', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContent({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/content.json`
      )
      .then((res) => {
        commit('setContent', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getPresenters({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/presenters.json`
      )
      .then((res) => {
        commit('setPresenters', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getTeaser({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/teaser.json`
      )
      .then((res) => {
        commit('setTeaser', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getFormular({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/formular.json`
      )
      .then((res) => {
        commit('setFormular', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getFormularFields({ commit, rootState }, { page }) {
    let company = rootState.language == 'de' ? 'unternehmen' : 'company'
    return this.$axios
      .get(
        `${rootState.language}/homepage/${company}/events/${page}/formular_fields.json`
      )
      .then((res) => {
        commit('setFormularFields', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
  // getFormular({ commit, rootState }, {page}) {
  //   return this.$ax/     .then((res) => {
  //       commit('setFormular', { data: res.data })
  //     })
  //     .catch((err) => {
  //       console.error(err)
  //     })
  // }
}
